// ALL VALUES ARE IN MILLISECONDS

export const MAKE_MAZE_SPEED = 20;
export const MAKE_VISITED_SPEED = 10;
export const MAKE_PATH_SPEED = 40; // 20 for dfs

// Values copied from file "constants.css"
export const WALL_ANIMATION_DURATION = 200;
export const WEIGHT_ANIMATION_DURATION = 200;
export const VISITED_ANIMATION_DURATION = 1200;
export const PATH_ANIMATION_DURATION = 1500;
